import axios from 'axios';
import { apiUrl } from '@/lib/apiBase';

/**
 * Upload diretto client → R2 (Presigned PUT). I binari non passano da FastAPI.
 * Se R2 è in mock o il PUT fallisce, fallback sul multipart locale.
 */
export async function uploadLeadDocuments({ leadId, files, sessionHeaders }) {
  const list = Array.from(files || []).filter(Boolean);
  if (!list.length) return 0;

  let uploaded = 0;
  const fallback = [];

  for (const file of list) {
    const contentType = file.type || 'application/pdf';
    try {
      const presign = await axios.post(
        apiUrl('/api/documents/presigned-upload'),
        {
          filename: file.name,
          content_type: contentType,
          lead_id: leadId,
        },
        { headers: sessionHeaders, withCredentials: false }
      );
      const data = presign.data || {};
      if (data.mock || !data.upload_url || !data.file_key) {
        fallback.push(file);
        continue;
      }
      await axios.put(data.upload_url, file, {
        headers: {
          'Content-Type': data.headers?.['Content-Type'] || contentType,
        },
        withCredentials: false,
      });
      await axios.post(
        apiUrl('/api/documents/confirm-upload'),
        {
          lead_id: leadId,
          filename: file.name,
          file_key: data.file_key,
          content_type: contentType,
        },
        { headers: sessionHeaders, withCredentials: false }
      );
      uploaded += 1;
    } catch {
      fallback.push(file);
    }
  }

  if (fallback.length) {
    const formDataUpload = new FormData();
    fallback.forEach((file) => formDataUpload.append('files', file));
    const uploadRes = await axios.post(
      apiUrl(`/api/leads/${leadId}/files`),
      formDataUpload,
      {
        headers: { ...sessionHeaders, 'Content-Type': 'multipart/form-data' },
        withCredentials: false,
      }
    );
    uploaded += Number(uploadRes.data?.uploaded_files?.length || fallback.length);
  }

  return uploaded;
}
